import React from "react";
const movieId = "";
const Movie = function () {
    return(
        <>

        </>
    )
};


export default Movie;